/**
 * The stock @customElement decorator from Lit will not check to see if
 * the element has already been registered. The Lit team is not going to
 * fix this, because they consider it out of scope for a decorator:
 * https://github.com/lit/lit-element/issues/207#issuecomment-423683185
 *
 * However, it's the sane default in all of our cases. It's also necessary
 * to prevent Storybook from accidentally re-registering the component
 * during development.
 *
 * Its API is identical to the @customElement decorator.
 */
function register(tagName, newElement) {
    const existing = customElements.get(tagName);
    if (!existing) {
        customElements.define(tagName, newElement);
    }
}
/**
 * Class decorator factory that defines the decorated class as a custom element.
 *
 * ```js
 * @customElement('my-element')
 * class MyElement extends LitElement {
 *   render() {
 *     return html``;
 *   }
 * }
 * ```
 * @category Decorator
 * @param tagName The tag name of the custom element to define.
 */
export const customElement = (tagName) => (classOrTarget, context) => {
    if (context !== undefined) {
        context.addInitializer(() => {
            register(tagName, classOrTarget);
        });
    }
    else {
        register(tagName, classOrTarget);
    }
};
//# sourceMappingURL=custom-element.js.map